<template>
  <div class="outside_drug">
    <uni-popup ref="leadDrugRight" type="bottom">
      <uni-card title="一人一方" :is-full="true" :note="true">
        <uni-search-bar
          v-model="searchCriteria"
          bg-color="#fff"
          placeholder="输入处方名称进行查找"
          :focus="focus"
          @oninput="searchInput"
          @confirm="searchForPatients"
          @cancel="deselecting"
        />
        <div class="gridClass">
          <div class="prescriptionBox">
            <block v-if="medicineList && medicineList.length > 0">
              <scroll-view
                :upper-threshold="-50"
                :scroll-top="0"
                :scroll-y="true"
                :scroll-anchoring="true"
                style="height: 18.346667rem"
                @scrolltolower="getMoreList"
              >
                <div
                  v-for="(item, index) in medicineList"
                  :key="index"
                  class="medicine"
                  @click="entireButton(item, index)"
                >
                  <div class="medicineText">
                    <div class="medicineTextTop">
                      {{ item.prescripTemplateNum }}
                    </div>
                    <div :class="['mdrug', 'medicineTextBottom']">
                      {{ item.prescripName }}
                    </div>
                  </div>
                  <div class="checkboxSty" :class="checked === index ? '' : 'isTrue'">
                    <img
                      class="img"
                      src="@funcPuzzle/mini_doctor/hook.png"
                    />
                  </div>
                </div>
              </scroll-view>
            </block>
            <gl-no-content v-else :title="'暂无处方记录'" />
          </div>
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="selectPrescrip">
            <span class="btn">选择该处方</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-oneperson-prescription
      ref="prescriptionWithPeople"
      v-model:visible="displayControl"
      :dogrobber="dogrobber"
      :drugList="drugList"
    />
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { mapState } from 'vuex'
import { getPrescripTemplate } from '@/views/funcPuzzle/utils/index.js'
import GlNoContent from '@/views/funcPuzzle/home/components/gl-no-content'
import MsOnepersonPrescription from '@/views/funcPuzzle/components/ms-oneperson-prescription/ms-oneperson-prescription.vue'

export default {
  components: {
    GlNoContent,
    MsOnepersonPrescription
  },
  computed: {
    ...mapState(['doctor'])
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    prescripList: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    prescripType: {
      type: [Object, String],
      default: ''
    },
    diagnosis: {
      type: [Object, String],
      default: ''
    },
    patientID: {
      type: [Object, String],
      default: ''
    },
    patientName: {
      type: [Object, String],
      default: ''
    },
    drugList: {
      type: Array,
      default: () => {
        return []
      }
    },
    warehouseID: {
      type: [String],
      default: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.open()
      } else {
        this.close()
      }
    },
    value(val) {
      this.$emit('input', val)
    },
    doctor: {
      handler(val) {},
      immediate: true
    }
  },
  data() {
    return {
      displayControl: false,
      searchCriteria: '',
      pages: {
        pageNum: 1,
        pageSize: 10
      },
      focus: false,
      medicineList: [],
      checked: '',
      boxes: {},
      dogrobber: ''
    }
  },
  methods: {
    getKeyValueText,
    // 输入搜索
    searchInput(e) {
      this.searchCriteria = e
      this.checked = ''
      this.pages.pageNum = 1
      this.medicineToSee()
    },
    searchForPatients() {
      this.checked = ''
      this.pages.pageNum = 1
      this.medicineToSee()
    },
    // 取消按钮点击
    deselecting() {
      this.searchCriteria = ''
      this.checked = ''
      this.pages.pageNum = 1
      this.medicineToSee()
    },
    medicineToSee() {
      getPrescripTemplate({
        pageNum: this.pages.pageNum,
        pageSize: this.pages.pageSize,
        hospitalID: this.doctor.hospitalID,
        keyword: this.searchCriteria,
        templateType: 4,
        warehouseID: this.warehouseID
      }).then(res => {
        if (res.code === 0 && res.PrescripTemplateList) {
          this.pages.pageNum === 1
            ? (this.medicineList = res.PrescripTemplateList)
            : this.medicineList.push(...res.PrescripTemplateList)
        }
      })
    },
    close() {
      if (!this.$refs.leadDrugRight) {
        return false
      }
      this.$emit('update:visible', false)
      this.searchCriteria = ''
      this.checked = ''
      this.$refs.leadDrugRight.close()
    },
    open() {
      this.$emit('update:visible', true)
      this.$refs.leadDrugRight.open()
      this.focus = true
      this.medicineToSee()
    },
    getMoreList() {
      this.pages.pageNum++
      this.medicineToSee()
    },
    entireButton(item, index) {
      this.checked = index
      this.boxes = item
    },
    selectPrescrip() {
      if (this.checked === '') {
        uni.showToast({
          title: '请先选择处方',
          icon: 'none'
        })
        return false
      }
      this.dogrobber = this.boxes
      this.$emit('setOnePreDrugs', this.dogrobber)
      this.$refs.prescriptionWithPeople.open()
      this.close()
    }
  },
  mounted() {
    this.pages.pageNum = 1
  }
}
</script>

<style lang="scss" scoped>
.outside_drug {
  width: 16rem;

  .gridClass {
    background-color: #fff;
    height: 18.346667rem;
    overflow-y: scroll;
    overflow-x: hidden;
    z-index: 1100;

    .prescriptionBox {
      margin-top: 0.426667rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .medicine {
        margin: 0 auto;
        width: 14.634667rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 0.021333rem solid #ececec;

        .medicineText {
          font-size: 0.64rem;
          color: #222;
          .medicineTextTop {
            margin: 0.682667rem 0;
          }
          .medicineTextBottom {
            margin-bottom: 0.682667rem;
          }
        }

        .checkboxSty {
          margin: 0.426667rem;
          width: 0.853333rem;
          height: 0.853333rem;
          border-radius: 0.853333rem;
          background-color: #0089ff;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 0.021333rem solid #0089ff;

          .img {
            width: 0.533333rem;
            height: 0.533333rem;
          }
        }

        .isTrue {
          background-color: #ffffff;
          border: 0.021333rem solid #cecece;
        }
      }
    }
  }

  .footer-box {
    text-align: center;
    width: 14.634667rem;
    height: 1.877333rem;
    background: #0089ff;
    border-radius: 0.938667rem;
    line-height: 1.877333rem;
    font-size: 0.682667rem;
    font-weight: 500;
    .btn {
      color: #fff;
    }
  }
}
</style>
